import { render } from "./MoodboardNotification.vue?vue&type=template&id=62d0a3bc&scoped=true"
import script from "./MoodboardNotification.vue?vue&type=script&lang=js"
export * from "./MoodboardNotification.vue?vue&type=script&lang=js"

import "./MoodboardNotification.vue?vue&type=style&index=0&id=62d0a3bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d0a3bc"]])

export default __exports__